import type { ModelData } from '@/shared/stores/model-utils'

export const doorWindowModelInitialModel: ModelData = {
  modelId: '',
  name: '',
  photoId: null,
  type: 'DOOR',
  width: 0,
  height: 0,
  description: '',
  parameters: [],
  doorConfiguration: {
    type: '',
    totalDoorWidth: 0,
    individualDoorWidth: [],
    totalHandles: 0,
    openingDirection: '',
    hingePosition: '',
  },
}
